<template>
    <component :is="component" :memberData="memberData" v-if="component" ></component>
</template>

<script>
export default {
    name: "MemberWriteLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        writeLayout: '',
        memberData: {default: () => {}},
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/member/write/MemberWriteDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.writeLayout) {
                return null
            }
            return () => import(`@/template/member/write/${this.writeLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
